export const photoCapturFraudWarningRequestReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { isFraudWarningApiStatus: false, fraudStatement: null });
};
//# sourceMappingURL=photoCaptureFraudWarningRequestReducer.js.map